import { useMemo } from 'react';

import { IUser } from 'models';
import { useUsers } from 'store/apis';

type UseTeamMembersProps = {
  searchKeyword: string;
  searchRoles: string[];
  setState?: (state: any) => void;
  revokeUserAccess?: (userId: number) => void;
};

type UseTeamMembers = (props: UseTeamMembersProps) => [boolean, any[]];

export const useTeamMembers: UseTeamMembers = ({
  searchKeyword,
  searchRoles,
  setState = () => {},
  revokeUserAccess = () => {},
}) => {
  const { data: users, isLoading } = useUsers();

  let teamMembers = [...(users || [])];

  /**
   * Filter users by keyword
   */
  const keyword = searchKeyword.trim().toLocaleLowerCase();

  if (keyword.length > 0) {
    teamMembers = teamMembers.filter((user) => {
      if (`${user.id}`.includes(keyword)) {
        return true;
      }

      if (user.name.toLowerCase().includes(keyword)) {
        return true;
      }

      if (user.email.toLowerCase().includes(keyword)) {
        return true;
      }

      return false;
    });
  }

  /**
   * Filter users by roles
   */
  if (searchRoles.length > 0) {
    teamMembers = teamMembers.filter((user: IUser) => {
      if (searchRoles.includes('no-access') && user.roles && user.roles.length === 0) {
        return true;
      }

      const roleNames = user.roles.map((role) => role.name);

      for (let i = 0; i < roleNames.length; i++) {
        if (searchRoles.includes(roleNames[i])) {
          return true;
        }
      }

      return false;
    });
  }

  /**
   * Add actions
   */
  const editUser = (user: IUser) =>
    setState((prev: any) => ({ ...prev, userId: user.id, visibleUserUpdateDialog: true }));

  const assignBuilding = (user: IUser) =>
    setState((prev: any) => ({ ...prev, userId: user.id, visibleUserAssignedBuildingsDialog: true }));

  const revokeAccess = (user: IUser) => revokeUserAccess(user.id);

  teamMembers = teamMembers.map((user) => ({
    ...user,
    editUser,
    assignBuilding,
    revokeAccess,
  }));

  return useMemo(() => {
    return [isLoading, teamMembers];
  }, [isLoading, teamMembers]);
};
